export type SqlVersionType = 'v1'|'v2';
export type SqlEncryptType = 'true'|'false'|'strict';

/***
 * additional properties
 */
export type SqlAdditionalPropertiesKeyType =
    | 'applicationIntent'
    | 'connectTimeout'
    | 'connectRetryCount'
    | 'connectRetryInterval'
    | 'loadBalanceTimeout'
    | 'commandTimeout'
    | 'integratedSecurity'
    | 'failoverPartner'
    | 'maxPoolSize'
    | 'minPoolSize'
    | 'multipleActiveResultSets'
    | 'multiSubnetFailover'
    | 'packetSize'
    | 'pooling';

export const sqlAdditionalPropertiesKeyList = [
    'applicationIntent',
    'connectTimeout',
    'connectRetryCount',
    'connectRetryInterval',
    'loadBalanceTimeout',
    'commandTimeout',
    'integratedSecurity',
    'failoverPartner',
    'maxPoolSize',
    'minPoolSize',
    'multipleActiveResultSets',
    'multiSubnetFailover',
    'packetSize',
    'pooling'
];

export const sqlAdditionalPropertiesAdapts = {
    applicationIntent: '*',
    connectTimeout: '*',
    connectRetryCount: '*',
    connectRetryInterval: '*',
    loadBalanceTimeout: '*',
    commandTimeout: '*',
    integratedSecurity: '*',
    failoverPartner: '*',
    maxPoolSize: '*',
    minPoolSize: '*',
    multipleActiveResultSets: '*',
    multiSubnetFailover: '*',
    packetSize: '*',
    pooling: '*'
};
